import getDatesIntervalWithSubtractMinutes from '../../../localUtils/getDatesIntervalWithSubtractMinutes'

export default function getHalfHourAgo() {
  const halfHourAgo = 30

  const dates = getDatesIntervalWithSubtractMinutes(halfHourAgo)

  const options = {
    name: 'HALF_HOUR_AGO',
    label: '30 Minutos',
    ...dates,
  }

  return options
}
